export const
    AUTH_USER_ERROR_HANDLED = 'auth_user_error_handled',
    AUTH_PENDING = 'auth_pending',
    AUTH_USER = 'auth_user',
    UNAUTH_USER = 'unauth_user',
    AUTH_ERROR = 'auth_error',
    REFRESH_PENDING = 'refresh_pending',
    REFRESH_USER = 'refresh_user',
    REFRESH_ERROR = 'refresh_error',
    FORGOT_PASSWORD_EMAIL_SENT = 'forgot_password_email_sent',
    EDITING_USER = 'editing_user';



// WEBPACK FOOTER //
// src/store/auth/types.js